import EnkLoader from "./common/loader"

interface IEnkErrorBoxProps {
  error: string | null
  loading: boolean
  children?: React.ReactNode
}
export default function EnkContentLoadingAndError(props: IEnkErrorBoxProps) {
  const { error, loading, children } = props
  return (
    <>
      {error ? (
        <div className="text-red-500 text-sm font-semibold py-2 px-4 bg-red-100 rounded-md mb-4">{error}</div>
      ) : loading ? (
        <EnkLoader />
      ) : (
        children
      )}
    </>
  )
}
